// Helpful? under the platform agent's finished answers and cards (D10). Wording from the Amigo design's copy sheet
// (Helpful?).
export default {
  question: 'Hyödyllinen?',
  helpful: 'Hyödyllinen',
  not_helpful: 'Ei hyödyllinen',
  thanks: 'Kiitos, merkitty.',
};
